import { Box, Flex } from '@chakra-ui/react';
import React from 'react';
import { useTokens } from '../../../context/TokenProvider';
const AiAssistBorder = ({ children, enableHover = true }) => {
    const tokens = useTokens();
    return (React.createElement(Flex, { "data-testid": "ai_assist_border", direction: "column", background: "linear-gradient(111deg,\n        #C76847 0%,\n        #955DE0 43.33%,\n        #2AA3A3 66.66%,\n        #C76847 100%)", backgroundSize: "150% 100%", backgroundPosition: "left center", borderRadius: tokens.BorderRadius04, padding: tokens.BorderWidth02, width: "fit-content", transition: "background-position 0.5s ease", _hover: enableHover
            ? {
                backgroundPosition: '150% 0%',
            }
            : undefined },
        React.createElement(Box, { background: tokens.Layer01, borderRadius: `calc(${tokens.BorderRadius04} - ${tokens.BorderWidth02})`, overflow: "hidden" }, children)));
};
export default AiAssistBorder;
